import { Outlet, createFileRoute } from "@tanstack/react-router";
import { RedirectTo } from "@/components/auth/redirect";
import { useAuthStatus } from "@/lib/use-auth-status";
import { safeRedirectPath } from "@/lib/utils";

type AuthSearch = { redirect?: string };

export const Route = createFileRoute("/_auth")({
  // Where to go once signed in. Only ever a path inside the app.
  validateSearch: (search): AuthSearch => ({
    redirect: safeRedirectPath(
      typeof search.redirect === "string" ? search.redirect : undefined,
    ),
  }),
  component: SignedOutOnly,
});

/** Pages for signed-out visitors. Anyone with a session is sent onwards. */
function SignedOutOnly() {
  const status = useAuthStatus();
  const { redirect } = Route.useSearch();
  if (status === "loading") return null;
  if (status === "signedIn") return <RedirectTo path={redirect ?? "/"} />;
  return <Outlet />;
}
